/**
 * TODO: shiver-app/shiver-adminで別れてしまっているのでここに統合していく
 * - https://github.com/legalscape/wklr-mono/blob/e2c5f05b93f510499869dc6732fe8de5d2c49026/packages/shiver-admin/src/types/index.ts#L1-L3
 * - https://github.com/legalscape/wklr-mono/blob/e2c5f05b93f510499869dc6732fe8de5d2c49026/packages/shiver-app/src/shared/types/contents.ts#L1
 */

import * as z from 'zod';
import { DOCUMENT_TYPE_KEYS, REGION_KEYS } from '../static.ts';

export const DocumentId = z.string().brand('DocumentId');
export type DocumentId = z.infer<typeof DocumentId>;

export const DocumentTypeKey = z.enum(DOCUMENT_TYPE_KEYS);
export type DocumentTypeKey = z.infer<typeof DocumentTypeKey>;

export const RegionKey = z.enum(REGION_KEYS);
export type RegionKey = z.infer<typeof RegionKey>;

export const DocumentSlug = z.string().brand('DocumentSlug');
export type DocumentSlug = z.infer<typeof DocumentSlug>;

export const AttributeSlug = z.string().brand('AttributeSlug');
export type AttributeSlug = z.infer<typeof AttributeSlug>;

// Elasticsearch検索用の最小構造（検索とフィルタに必要なフィールドのみ）
export const DocumentForSearch = z.object({
  id: z.string(), // DB参照用
  title: z.string(), // 検索対象
  lede: z.string().nullable(), // 検索対象
  textHtml: z.string().nullable(), // 検索対象
  type: z.object({
    key: DocumentTypeKey, // フィルタ用
  }),
  regions: z.array(
    z.object({
      key: RegionKey, // フィルタ用
    }),
  ),
  publishedAt: z.coerce.date().nullable(), // フィルタ用
  series: z.array(z.object({ id: z.string() })).default([]), // フィルタ用
});
export type DocumentForSearch = z.infer<typeof DocumentForSearch>;
